/* import __COLOCATED_TEMPLATE__ from './ties.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();